import React from "react";
import AboutMe from "../components/AboutMe";
import AnimatedText from "../components/AnimatedText";

function About() {
  return (
    <main>
      <section
        className="about-content"
        style={{
          backgroundImage: "url('./image/about-hero.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="text-center d-flex flex-column justify-content-center align-items-center gap-3 vh-65">
          {/* <h6 className="about-text">
              <span
                style={{ color: "#F1E4E4BF" }}
                className="animate-fade-right"
              >
                Nice to meet you! I turn{" "}
              </span>
              <span className="text-highlight animate-bounce">
                human behavior{" "}
              </span>
              <span
                style={{ color: "#F1E4E4BF" }}
                className="animate-fade-left"
              >
                into
              </span>
              <span className="text-highlight animate-fade-left">
                {" "}
                intuitive design.
              </span>
            </h6> */}
          <AnimatedText />
        </div>
      </section>
      <section className="container mt-4">
        <AboutMe />
      </section>
    </main>
    // <footer className="py-3">
    //   <div className="container">
    //     <div className="d-flex justify-content-end align-items-center flex-wrap">
    //       <ul className="list-unstyled d-flex gap-3 mb-0">
    //         <li className="grayscale">
    //           <a
    //             href="https://dribbble.com/chinazaeskay"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //           >
    //             <img
    //               className="rounded-1"
    //               style={{ objectFit: "cover" }}
    //               src="/image/dribble.png"
    //               alt="Dribble"
    //               width="25px"
    //               height="25px"
    //             />
    //           </a>
    //         </li>
    //         <li className="grayscale">
    //           <a
    //             href="https://www.behance.net/chinazaeskay"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //           >
    //             <img src="/image/behance.png" alt="Be-icon" width="20px" />
    //           </a>
    //         </li>
    //         <li className="grayscale">
    //           <a
    //             href="http://linkedin.com/in/chinaza-eskay-108443233"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //           >
    //             <img
    //               src="/image/linkedin.png"
    //               alt="Linkedin-icon"
    //               width="20px"
    //             />
    //           </a>
    //         </li>
    //       </ul>
    //     </div>
    //   </div>
    // </footer>
  );
}

export default About;
